export default __webpack_public_path__ + "static/media/logomark-ccolor.784ffdea.svg";